module.exports = __webpack_public_path__ + "static/media/bank1.9563f5cc.png";